import React, { useEffect, useState } from 'react';
import headerBrandLogo from '../../static/images/logo_DQ.png';
import mobileAppLogo from '../../static/images/dq_logo.png';
import { isNativeApp } from '../../utils/nativeApp.js';

/** Same box for company + DigiQin default (any source image size). */
const HEADER_LOGO_CLASS =
  'h-11 sm:h-14 w-auto max-h-11 sm:max-h-14 max-w-[168px] sm:max-w-[280px] object-contain object-left flex-shrink-0';

const VARIANT_CLASSES = {
  header: {
    logo: HEADER_LOGO_CLASS,
  },
  sidebarMobile: {
    logo: 'h-10 w-auto max-w-[170px] object-contain flex-shrink-0',
  },
};

export default function AppBrandLogo({ companyLogo, variant = 'header', className = '', alt = 'Company logo', onClick }) {
  const wrap = (node) => (
    onClick ? (
      <button
        type="button"
        onClick={onClick}
        className="cursor-pointer bg-transparent border-0 p-0 leading-none"
        title="Refresh"
        aria-label="Refresh page"
      >
        {node}
      </button>
    ) : node
  );
  const classes = VARIANT_CLASSES[variant] || VARIANT_CLASSES.header;
  const logoClass = className || classes.logo;
  const [companyFailed, setCompanyFailed] = useState(false);
  // Keep last good company logo so remount/reload does not flash the default brand
  const [stableCompanyLogo, setStableCompanyLogo] = useState(companyLogo || null);
  const nativeApp = isNativeApp();

  useEffect(() => {
    if (companyLogo) {
      setCompanyFailed(false);
      setStableCompanyLogo(companyLogo);
    }
  }, [companyLogo]);

  const activeCompanyLogo = companyLogo || stableCompanyLogo;
  const showCompany = activeCompanyLogo && !companyFailed;

  if (showCompany) {
    return wrap(
      <img
        src={activeCompanyLogo}
        alt={alt}
        className={logoClass}
        decoding="async"
        onError={() => setCompanyFailed(true)}
      />
    );
  }

  // Native app and mobile web use dq_logo.png; desktop web keeps the DigiQin wordmark.
  if (variant === 'header') {
    if (nativeApp) {
      return wrap(
        <img
          src={mobileAppLogo}
          alt="DigiQin"
          className={logoClass}
          decoding="async"
        />
      );
    }
    return wrap(
      <>
        <img
          src={mobileAppLogo}
          alt="DigiQin"
          className={`sm:hidden ${logoClass}`}
          decoding="async"
        />
        <img
          src={headerBrandLogo}
          alt="DigiQin"
          className={`hidden sm:block ${logoClass}`}
          decoding="async"
        />
      </>
    );
  }

  return (
    <img
      src={mobileAppLogo}
      alt="DigiQin"
      className={logoClass}
      decoding="async"
    />
  );
}
